import React, { FC } from 'react'
import { createRoot } from 'react-dom/client'
import { Config } from './types/global'
import config from './reapit.config.json'
import { datadogRum } from '@datadog/browser-rum'

datadogRum.init({
    applicationId: '1ef492f4-ead2-47c7-8fde-48cdbc1eaa5f',
    clientToken: 'pubd3c1ec84a5cf056a82189100d054356d',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.eu',
    service: 'reapit',
    env: 'prod',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
})

// Init global config
window.reapit = {
    config: {
        appEnv: 'local',
        connectClientId: '',
        connectOAuthUrl: '',
        connectUserPoolId: '',
        platformApiUrl: '',
        marketplaceUrl: '',
    },
}

export const renderApp = (Component: FC) => {
    const rootElement = document.querySelector('#root') || document.body
    const isDesktop = Boolean(window['__REAPIT_MARKETPLACE_GLOBALS__'])
    const html = document.querySelector('html')

    if (isDesktop && html) {
        html.classList.add('is-desktop')
    }

    if (rootElement) {
        createRoot(rootElement).render(<Component />)
    }
}

const run = async () => {
    try {
        const globalConfig: Config = config
        // Set the global config
        window.reapit.config = globalConfig

        // I import the app dynamically so that the config is set on window and I avoid any
        // runtime issues where config is undefined
        const { default: App } = await import('./core/app')

        renderApp(App)
    } catch (error) {
        console.error('Cannot fetch config', error)
    }
}

run()
